export enum CheckSuitableForMovingOrderEnum {
    PartialSuitable = 0,
    NotSuitable = 1,
    TotalSuitable = 2,
    Deadline = 3,
    DeadlineStopMoving = 4,
    NotSupport=5,
    Holiday = 6

}